import React, {useEffect} from "react";
import { connect } from "react-redux";
import Card from "components/card";
import SearchFilter from "components/search/SearchFilter";
import TeamCard from "./TeamCard";
import PopupButton from "components/button/PopupButton";
import ClientTeamForm from "./ClientTeamForm";
import { 
    getClientTeamList
} from "../../../../../redux/client/clientState";
import {
    Users
} from "lucide-react";

const Teams = ({ 
    recordList, 
    pagination, 
    doSearch, 
    filters, 
    clientId 
}) => {

    useEffect(() => {
        if (clientId) {
            doSearch({paginate: pagination.per_page, clientId});
        } 
    }, [doSearch, clientId, pagination.per_page]);

    return (
        <Card className="flex flex-col overflow-hidden border rounded-xl p-6">
            <div className="space-y-6">
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                    <div>
                        <h2 className="text-2xl sm:text-3xl label-gradient emerald">
                            Teams & Departments
                        </h2>
                        <p className="text-sm text-slate-700 mt-1">
                            {recordList?.length ?? 0} teams  in your organization
                        </p>
                    </div>
                    <div className="w-full sm:w-auto">
                        <SearchFilter
                            placeholder="Search teams..."
                            searchHandler={doSearch} 
                            filters={filters} 
                            pagination={pagination}
                        />
                    </div>
                    <PopupButton 
                        id="add_client_team" 
                        title="Add Client Team" 
                        label="Add" 
                        btnClass="btn-small"
                        useCustomClass={true}
                        modalWidth={500}
                        description="Fill in the details below"
                    >
                        <ClientTeamForm recordId={0} mode="edit" clientId={clientId} />
                    </PopupButton>
                </div>
                <div className="list-3-column gap-6">
                    {recordList && recordList?.length > 0 ? (
                        recordList?.map((team) => {
                            return (
                                <TeamCard
                                    key={team?.cte_id}
                                    {...team}
                                />
                            );
                        })
                    ) : (
                        <div className="col-span-3">
                            <div className="px-6 pb-6 flex flex-col items-center justify-center py-12 text-center">
                                <Users className="w-16 h-16 mb-4 opacity-50 muted-text" />
                                <h4 className="text-[16px] font-semibold mb-2 title-text">
                                    No Team Found
                                </h4>
                                <p className="text-[13px] max-w-sm muted-text">
                                    Try adjusting your search or filters
                                </p>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Card>
    );
};

const mapStateToProps = (state) => ({
    recordList: state.client.clientTeamList?.items,
    pagination: state.client.clientTeamList?.pagination,
    filters: state.client.clientTeamList?.filters,
    requesting: state.client.clientTeamList?.requesting,
    error: state.client.clientTeamList?.error,
});

const mapDispatchToProps = (dispatch) => ({
    doSearch: (filters) => dispatch(getClientTeamList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Teams);